<div class="container-fluid support-ticket-list-wrapper">
  <div class="row">
    <div class="col-12 col-md-6 col-lg-6 text-left mb-2">
      <ng-container *ngIf="csvData; else buttonLoadingVisual">
        <angular2csv
          [data]="csvData"
          filename="{{ 'Support_Ticket_Data_' + csvReportDate }}"
          [options]="csvReportOptions">
        </angular2csv>
      </ng-container>
      <ng-template #buttonLoadingVisual>
        <div class="loadingButtonVisual"></div>
      </ng-template>
    </div>
    <!-- <div class="col-12 col-md-6 col-lg-3">
      <app-search-input
        class="search-input text-right"
        (inputValue)="searchValue = $event">
      </app-search-input>
    </div> -->
    <div
      class="col-12 col-md-6 d-flex justify-content-end support-date-range-picker mb-2">
      <app-date-range-picker
        [dateRangeForm]="dateRangeForm"
        label="Date"
        startPlaceholder="Start date"
        endPlaceholder="End date"
        [maxDate]="maxDate"
        [startDate]="startDate"
        [endDate]="endDate"
        [isDateRangeValid]="isDateRangeValid">
      </app-date-range-picker>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <ng-container *ngIf="isCasesLoading$ | async; else content">
        <app-table-loading-visual></app-table-loading-visual>
      </ng-container>
      <ng-template #content>
        <ng-container *ngIf="supportCases$ | async as supportCases">
          <ng-container>
            <app-support-list-table
              *ngIf="supportCases"
              [allData]="supportCases"
              [searchText]="searchValue"
              [caseTypes]="caseTypes">
            </app-support-list-table>
          </ng-container>
          <ng-template #noTicketsVisual>
            <div class="empty-table-warning-container">
              <img alt="Truck Logo" src="assets/images/truck-gears.svg" />
              <div class="empty-table-warning">No Support Tickets Yet</div>
            </div>
          </ng-template>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>
